module.exports = __webpack_public_path__ + "img/sonicare.7ed33110.jpg";